// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "#575757";
var _3 = "direction-XRdR";
var _4 = "1.5rem";
var _5 = "#dedede";
var _6 = "#adf";
var _7 = "1rem";
var _8 = "#bebebe";
var _9 = "nodeUsageList-Uwgh";
var _a = "place-mTxF";
var _b = ".8rem";
var _c = "topic-Pm4z";
var _d = "transitTypeLinkWrapper-ygBU";
var _e = "#000";
var _f = "usageListItem-sBkE";
export { _1 as "busBlue", _2 as "darkGrey", _3 as "direction", _4 as "extraLargeFontSize", _5 as "lightGrey", _6 as "lightblue", _7 as "mediumFontSize", _8 as "mediumLightGrey", _9 as "nodeUsageList", _a as "place", _b as "smallFontSize", _c as "topic", _d as "transitTypeLinkWrapper", _e as "unusedNodeColor", _f as "usageListItem" }
